import { eLopActionsObj } from "../../action-types/category/ILopActions";
import { generateActions } from "../generateActions";

export const lopActions = {
    ...generateActions(eLopActionsObj, "LOP"),
}